import gql from 'graphql-tag';

const CAMPAIGN_ORDER_TRANSACTION_PUBLISHERS_BY_DATES_PAGINATED = gql`
  query campaignOrderTransactionPublishersByDatesPaginated(
    $where: CampaignOrderTransactionPublishersByDateWhereInput!
    $first: Int
    $skip: Int
    $orderBy: CampaignOrderTransactionPublishersByDateOrderByInput
  ) {
    campaignOrderTransactionPublishersByDatesConnection(
      first: $first
      skip: $skip
      orderBy: $orderBy
      where: $where
    ) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          date
          transactions
          impressions
          publisher {
            media
            name
          }
        }
      }
      aggregate {
        count
      }
    }
    full: campaignOrderTransactionPublishersByDatesConnection(where: $where) {
      aggregate {
        count
      }
    }
  }
`;

export default CAMPAIGN_ORDER_TRANSACTION_PUBLISHERS_BY_DATES_PAGINATED;
